import React from "react";
import { usePageSeo } from "../utils/seo";

function TermsOfService() {
  usePageSeo({
    title: "Terms of Service | Buzz Mobile",
    description:
      "Terms of Service for using the Buzz Mobile website, services, orders, repair information, and online content.",
    canonicalPath: "/terms-of-service",
  });

  return (
    <main className="privacy-policy-page">
      <section className="container privacy-policy">
        <header className="privacy-policy__header">
          <span>Last updated: July 2, 2026</span>
          <h1>Terms of Service</h1>
          <p>
            These Terms of Service explain the rules for using the Buzz Mobile
            website, online content, product information, service information,
            order features, and official social media integrations.
          </p>
          <p>
            By using our website or contacting Buzz Mobile through our online
            channels, you agree to these terms.
          </p>
        </header>

        <div className="privacy-policy__content">
          <section>
            <h2>1. About Buzz Mobile</h2>
            <p>
              Buzz Mobile is a mobile phone shop and service provider based in
              Strumica, North Macedonia. We provide information about mobile
              phones, accessories, repair services, offers, and related content.
            </p>
          </section>

          <section>
            <h2>2. Website Use</h2>
            <p>
              You agree to use this website only for lawful purposes and in a
              way that does not harm the website, interfere with its operation,
              or attempt unauthorized access to our systems, accounts, data, or
              services.
            </p>
          </section>

          <section>
            <h2>3. Product And Service Information</h2>
            <p>
              We try to keep product, pricing, availability, repair, and service
              information accurate and up to date. However, information on the
              website may change without notice and may contain errors or delays.
            </p>
            <p>
              Final product availability, pricing, repair pricing, warranty
              details, delivery details, and service conditions may be confirmed
              directly by Buzz Mobile before an order or service is completed.
            </p>
          </section>

          <section>
            <h2>4. Orders And Requests</h2>
            <p>
              When you submit an order, contact form, service request, or status
              request, you agree to provide accurate and complete information.
              Buzz Mobile may contact you to confirm details before processing
              an order, delivery, pickup, or repair service.
            </p>
          </section>

          <section>
            <h2>5. Repairs And Service Status</h2>
            <p>
              Service status information is provided for convenience and may be
              updated as repair work progresses. Estimated service times,
              availability of parts, and final repair costs may vary depending
              on device condition, diagnostics, and supplier availability.
            </p>
          </section>

          <section>
            <h2>6. Facebook / Meta Integrations</h2>
            <p>
              Buzz Mobile may use Meta/Facebook API tools to manage and publish
              content on official Buzz Mobile Facebook Page(s), such as blog
              posts, promotions, product updates, or website links.
            </p>
            <p>
              We do not use Facebook Login for website visitors and do not use
              this website to collect personal Facebook profile data from
              visitors or customers.
            </p>
          </section>

          <section>
            <h2>7. Intellectual Property</h2>
            <p>
              Website content, branding, images, text, layouts, and other
              materials are owned by Buzz Mobile or used with permission. You may
              not copy, reproduce, distribute, or misuse website content without
              permission, except where allowed by law.
            </p>
          </section>

          <section>
            <h2>8. Third-Party Links</h2>
            <p>
              Our website may link to third-party websites, social media pages,
              maps, payment providers, delivery providers, or other external
              services. We are not responsible for the content, policies, or
              practices of third-party websites or services.
            </p>
          </section>

          <section>
            <h2>9. Limitation Of Liability</h2>
            <p>
              Buzz Mobile provides this website and its content on an
              informational basis. To the maximum extent allowed by applicable
              law, we are not liable for indirect, incidental, or consequential
              damages caused by use of the website, temporary unavailability,
              incorrect information, or third-party services.
            </p>
          </section>

          <section>
            <h2>10. Changes To These Terms</h2>
            <p>
              We may update these Terms of Service from time to time. Any
              changes will be published on this page with an updated "Last
              updated" date.
            </p>
          </section>

          <section>
            <h2>11. Contact Us</h2>
            <p>
              If you have questions about these Terms of Service, you can
              contact us at:
            </p>
            <address>
              <strong>Buzz Mobile</strong>
              <span>Strumica, North Macedonia</span>
              <a href="mailto:buzzmobiledooel@gmail.com">
                buzzmobiledooel@gmail.com
              </a>
              <a href="https://buzzmobile.mk/">https://buzzmobile.mk/</a>
            </address>
          </section>
        </div>
      </section>
    </main>
  );
}

export default TermsOfService;
